import { Card, Skeleton, Space } from "antd";
import React from "react";

type SkeletonCollapseProps = {
  itemsCount?: number;
};

const SkeletonCollapse: React.FC<SkeletonCollapseProps> = ({
  itemsCount = 3,
}) => {
  return (
    <Space direction="vertical" style={{ width: "100%" }}>
      {Array.from({ length: itemsCount }).map((_, index) => (
        <Card
          variant="borderless"
          key={index}
          style={{ padding: 0, borderRadius: 8 }}
          styles={{ body: { padding: "16px" } }}
        >
          <Skeleton
            active
            title={{ width: "80%" }}
            paragraph={{ rows: 0, width: "60%" }}
          />
        </Card>
      ))}
    </Space>
  );
};

export default SkeletonCollapse;
